<script>
import TextInput from "@/components/TextInput";
import Message from "@/components/ErrorMessage";
import { useUserStore } from "../stores/user";
const statusCodes = {
  200: "views.reset_password.200",
  400: "views.reset_password.400",
  422: "views.reset_password.422",
};
export default {
  setup() {
    const userStore = useUserStore();
    return {
      userStore
    };
  },
  components: {
    TextInput,
    Message,
  },
  data() {
    return {
      email: this.$route.query.email,
      token: this.$route.query.token,
      password: "",
      passwordConfirm: "",
      message: null,
    };
  },
  methods: {
    async reset() {
      const { password, passwordConfirm, email, token } = this;
      if (password !== passwordConfirm) {
        this.message = {
          status: 500,
          message: "views.reset_password.message",
        };
        return;
      }

      const res = await this.userStore.resetPassword({
        password,
        email,
        token,
      });
      if (res) {
        this.message = {
          status: res.status,
          message:
            statusCodes[res.status] || res.data.message || res.statusText,
        };
        return;
      }
      this.message = {
        status: 200,
        message: statusCodes[200],
      };
      setTimeout(() => {
        this.$router.push("/signup-login");
      }, 1500);
    },
  },
};
</script>

<template>
  <div class="mt-10 text-gray-700">
    <h1 class="text-2xl font-semibold">
      {{ $t("views.reset_password.title") }}
    </h1>
    <p class="mt-4">
      {{ $t("views.reset_password.infos.1") }}
    </p>
    <p class="mt-4">
      {{ $t("views.reset_password.infos.2") }}
    </p>
    <div class="mt-6">
      <Message v-if="message" :value="message" @input="message = null" />
      <form v-if="!message || message.status !== 200" @submit.prevent="reset">
        <TextInput id="pass" v-model="password" :label="$t('views.reset_password.password')" type="password"
          class="mt-4 w-1/2" />
        <TextInput id="confirmPass" v-model="passwordConfirm" :label="$t('views.reset_password.confirm_password')"
          type="password" class="mt-4 w-1/2" />
        <button type="submit" class="mt-4 p-3 bg-airbnbRed text-white text-sm font-semibold rounded ml-auto">
          {{ $t("views.reset_password.send") }}
        </button>
      </form>
    </div>
  </div>
</template>
